import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';

import Style from './ContextPromo.module.scss';

const ContextPromo = ({ onClickCTA, promoImage, promoLogo, promoDescription, promoCTA: CTA }) => (
  <div className={Style.promo}>
    <div className={Style.promoContent}>
      <div className={Style.promoImage}>
        <img alt="" src={promoImage} />
      </div>
      <div className={Style.promoDetails}>
        <div className={Style.promoLogo}>
          <img alt="" src={promoLogo} />
        </div>
        <div className={Style.promoDescription}>{promoDescription}</div>
      </div>
    </div>
    <div className={Style.promoCTA}>
      <button className={Style.btn} onClick={onClickCTA}>
        {CTA}
      </button>
    </div>
  </div>
);

ContextPromo.defaultProps = {
  onClickCTA: noop,
  promoImage: '',
  promoLogo: '',
  promoDescription: '',
  promoCTA: '',
};

ContextPromo.propTypes = {
  onClickCTA: PropTypes.func,
  promoImage: PropTypes.string,
  promoLogo: PropTypes.string,
  promoDescription: PropTypes.string,
  promoCTA: PropTypes.string,
};

export default ContextPromo;
